import React from 'react'
import { XStack, Switch } from 'tamagui'
import { CobuText } from '@cobu/ui'

type ProfileSwitchItemProps = {
  title: string
  value: boolean
  onValueChange: (value: boolean) => void
  isFirstItem?: boolean
  isLastItem?: boolean
}

export default function ProfileSwitchItem({ title, value, onValueChange, isFirstItem = false, isLastItem = false }: ProfileSwitchItemProps) {
  return (
    <XStack
      alignItems="center"
      justifyContent="space-between"
      paddingHorizontal="$3"
      height={56}
      borderTopWidth={isFirstItem ? 0 : 1}
      borderBottomWidth={isLastItem ? 0 : 1}
      borderColor="rgba(0, 0, 0, 0.08)"
      borderLeftWidth={0}
      borderRightWidth={0}
      backgroundColor="$background"
      onPress={() => onValueChange(!value)}
      role="button"
      tabIndex={0}
    >
      <CobuText>{title}</CobuText>
      <XStack backgroundColor="$white" padding={2} borderRadius={9999}>
        <Switch
          size="$3"
          checked={value}
          onCheckedChange={onValueChange}
          aria-label={title}
          width={47}
          height={27}
          borderRadius={9999}
          borderWidth={1}
          borderColor={value ? ('$cobuTopaz' as any) : ('$borderColorLight' as any)}
          backgroundColor={value ? ('$cobuTopaz' as any) : ('$colorMuted' as any)}
          animation="bouncy"
        >
          <Switch.Thumb backgroundColor="$white" width={25} height={25} borderRadius={9999} animation="bouncy" />
        </Switch>
      </XStack>
    </XStack>
  )
}


